// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Action imports
import { addScatterPlotSecurities, removeScatterPlotSecurity, setScatterPlotSecurities, toggleScatterPlotSecurity, updateScatterPlotSecurityOrdering, } from './securities.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
// In this context "securities" refers to both individual securities and security lists
export const securities = createReducer([], on(addScatterPlotSecurities, (state, action) => {
    const newState = [...state];
    action.scatterPlotSecurities.forEach((newSecurity) => {
        const duplicateSecurityIndex = newState.findIndex((sec) => sec.id === newSecurity.id && sec.type === newSecurity.type);
        if (duplicateSecurityIndex > -1) {
            // If a security is being added that already exists in state as an override security,
            // then we want to replace the override security (by removing the parent_security_list property)
            if (newState[duplicateSecurityIndex].parent_security_list) {
                newState.splice(duplicateSecurityIndex, 1);
                newState.push(newSecurity);
            }
        }
        else {
            newState.push(newSecurity);
        }
    });
    return newState;
}), on(removeScatterPlotSecurity, (state, action) => {
    return state.filter((security) => {
        // When a list is removed, we also want to remove the security overrides that were part of that list.
        if (security.parent_security_list === action.scatterPlotSecurity.id)
            return false;
        // Filter out the security / list that we are removing.
        return security.id !== action.scatterPlotSecurity.id;
    });
}), on(setScatterPlotSecurities, (state, action) => {
    return action.scatterPlotSecurities;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.securities;
}), on(toggleScatterPlotSecurity, (state, action) => {
    return state.map((security) => {
        if (security.id === action.scatterPlotSecurity.id) {
            const include = !security.include;
            return { ...security, include };
        }
        return security;
    });
}), on(updateScatterPlotSecurityOrdering, (state, action) => {
    const updatedOrdering = [...state];
    const { oldIndex, newIndex } = action;
    updatedOrdering.splice(newIndex, 0, updatedOrdering.splice(oldIndex, 1)[0]);
    return updatedOrdering;
}));
